// Generator-discovered file route for the brief form. Component lives in
// `src/ad/routes/brief.tsx` (Module K / K3).
import { createFileRoute } from '@tanstack/react-router';
import { BriefRouteComponent } from '@/ad/routes/brief';

export const Route = createFileRoute('/_authenticated/ad/brief')({
  component: BriefRouteComponent,
});
